import React from 'react';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import BaseForm from '../../../../../components/form/BaseForm';
import Input from '../../../../../components/input/Input/Input';
import Select from '../../../../../components/input/Select/Select';
import SearchBox from '../../../../../components/outline/SearchBox';
import { RECOMMEND_STORE_TYPE_SELECT_LIST } from '../../../../../constants/service/app/recommendStoreConstants';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import {
  RECOMMEND_STORE_LIST_SEARCH_DATA_MODEL,
  RECOMMEND_STORE_LIST_SEARCH_OPTION_MODEL,
} from '../../../../../store/modules/recommend/store/models';
import { addAllItemToSelectList } from '../../../../../lib/common';
import './RecommendStoreListSearchBox.scss';

const RecommendStoreListSearchBox = (props) => {
  const { setData, searchData, getList } = props;
  const { recommendStoreType, adminName, memo, createDate } = searchData;

  return (
    <SearchBox
      className="recommend-store-list-search-box"
      onSearch={() => {
        getList({
          searchOption: searchData,
          pagination: _LIST_PAGINATION_MODEL,
        });
      }}
      onClear={() => {
        getList({
          searchOption: RECOMMEND_STORE_LIST_SEARCH_OPTION_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
          isInit: true,
        });
        setData({
          path: [],
          value: RECOMMEND_STORE_LIST_SEARCH_DATA_MODEL,
        });
      }}
    >
      {/*추천 브랜드 타입*/}
      <BaseForm
        label="추천 타입"
        content={
          <Select
            list={addAllItemToSelectList(RECOMMEND_STORE_TYPE_SELECT_LIST)}
            onChange={(value) =>
              setData({
                path: ['recommendStoreType'],
                value,
              })
            }
            defaultValue={recommendStoreType}
            value={recommendStoreType}
            isTable={false}
          />
        }
      />

      {/*추천인 검색*/}
      <BaseForm
        label="추천인"
        content={
          <Input
            value={adminName}
            onChange={(value) =>
              setData({
                path: ['adminName'],
                value,
              })
            }
            onPressEnter={() =>
              getList({
                searchOption: searchData,
                pagination: _LIST_PAGINATION_MODEL,
              })
            }
            maxLength={30}
            size="large"
          />
        }
      />

      {/*메모 검색*/}
      <BaseForm
        label="메모"
        content={
          <Input
            value={memo}
            onChange={(value) =>
              setData({
                path: ['memo'],
                value,
              })
            }
            onPressEnter={() =>
              getList({
                searchOption: searchData,
                pagination: _LIST_PAGINATION_MODEL,
              })
            }
            maxLength={30}
            size="large"
          />
        }
      />

      {/*추천 브랜드 생성일*/}
      <BaseForm
        label="추천 브랜드 생성일"
        content={
          <DateRangePicker
            value={createDate}
            format={DATE_FORMAT.YMD_DASH_FORMAT}
            outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            btnTextFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            onSelect={(value) =>
              setData({
                path: ['createDate'],
                value,
              })
            }
          />
        }
      />
    </SearchBox>
  );
};

export default RecommendStoreListSearchBox;
